import React from "react";

export const Wordmark = ({ size = "md", subtitle = true, className = "" }) => {
    const sizes = {
        sm: "text-3xl sm:text-4xl",
        md: "text-4xl sm:text-5xl",
        lg: "text-5xl sm:text-6xl lg:text-7xl",
        xl: "text-6xl sm:text-7xl lg:text-8xl",
    };
    return (
        <div className={`flex flex-col items-center ${className}`} data-testid="brand-wordmark">
            <h1
                className={`font-cursive gold-shimmer wordmark-glow leading-none ${sizes[size]}`}
                style={{ lineHeight: 1.05 }}
            >
                Real Estate
                <span className="inline-block mx-1 text-[0.6em] align-middle font-serif-editorial text-brand-silver">&amp;</span>
                Administration
            </h1>
            {subtitle && (
                <span className="mt-1 text-[0.65rem] sm:text-xs tracking-[0.55em] text-brand-silver/80 uppercase font-sans">
                    Incorporated · Las Vegas
                </span>
            )}
        </div>
    );
};

export default Wordmark;
